import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './StorySection.module.scss';
import productService from '../../../services/productService';

const StorySection = () => {
  const [story, setStory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    productService.getPageContent('cau-chuyen-tram')
      .then(res => {
        setStory(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Lỗi tải câu chuyện:", err);
        setLoading(false);
        // Fallback content dài hơn một chút để demo layout
        setStory({ 
          title: "Hương Của Vết Thương", 
          content: "<p>Từ hàng ngàn năm trước, trong nền văn hóa Á Đông, một cái tên đã được người xưa tôn xưng bằng những mỹ từ cao quý 'Thọ thiên địa chi khí'. Loại ngôn ngữ cổ nhất của người Việt nhắc đến một loài gỗ được gọi là Vua của các loài Hương. Không chỉ là một loài hương đặc biệt, mà còn được xem như báu vật, là tinh hoa của đất trời kết tụ qua ngàn năm gió sương.</p>" 
        });
      });
  }, []);

  if (loading) {
    return <div className={styles.loadingContainer}>Loading...</div>;
  }

  return (
    <div className={styles.parallaxContainer}>
      <div className={styles.storyContentOverlay}></div>
      
      <div className={styles.storyCard}>
        <div className={styles.cardInner}>
          <span className={styles.subTitle}>Câu chuyện trầm hương</span>
          
          {/* Tiêu đề */}
          <h2 className={styles.storyTitle}>
            {story?.title || "Hương Của Vết Thương"}
          </h2>
          
          {/* Nội dung trích đoạn */}
          <div className={styles.storyExcerpt}>
            <div dangerouslySetInnerHTML={{ 
              __html: story?.content || "<p>Trầm hương là món quà của khổ đau, là sự kết tinh từ những vết thương của cây Dó Bầu...</p>" 
            }} />
          </div>

          <Link to="/cau-chuyen" className={styles.readMoreBtn}>
            Đọc Tiếp Câu Chuyện &rarr;
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StorySection;